import React from "react";
import { useTranslation } from "react-i18next";
import AutosizeTextarea from "../AutosizeTextarea";

const NotesEditor = ({ classNames, value, handleChange, onSave }) => {
  const { t } = useTranslation(["coaching-portal", "common"]);
  const [focused, setFocused] = React.useState(false);

  return (
    <div className={`${classNames}`}>
      <div>
        <header>{t("common:notes")}</header>
        <AutosizeTextarea
          name="notes"
          value={value}
          handleChange={handleChange}
          placeholder={t("coaching-portal:notesEditor.placeholder")}
          setFocused={setFocused}
          initialRows={2}
        />
      </div>
      {focused && (
        <button data-button-type="outline" onClick={onSave}>
          <span>{t("common:save")}</span>
        </button>
      )}
    </div>
  );
};

export default NotesEditor;
